// Design tokens y estilos compartidos por la sección de Ayuda (mobile y desktop).

import { createTheme } from '@mui/material/styles';

// Toda la sección usa Inter; Poppins queda reservada para el título del hero ("Ayuda").
export const helpFonts = {
  body: "'Inter', 'Helvetica', 'Arial', sans-serif",
  title: "'Poppins', 'Helvetica', 'Arial', sans-serif",
};

// Theme propio: los Typography de MUI toman la fuente del theme y no del contenedor.
// Sin responsiveFontSizes a propósito: le ganaba al fontSize declarado en cada sx.
export const helpTheme = createTheme({
  typography: { fontFamily: helpFonts.body },
});

// Clase del título del hero ("Ayuda"), la única pieza que va en Poppins.
export const HELP_TITLE_CLASS = 'helpHeroTitle';

// El theme solo no alcanza: headerStyle.css (presente en todas las páginas) declara
// `* { font-family: 'Poppins' !important }` y hay que ganarle en especificidad.
export const helpFontScopeSx = {
  '&, & *': { fontFamily: `${helpFonts.body} !important` },
  [`& .${HELP_TITLE_CLASS}`]: { fontFamily: `${helpFonts.title} !important` },
};

export const helpColors = {
  pink: '#DA0067',
  pinkDark: '#B5004F',
  pink50: '#FDE7EF',
  pink100: '#FBD3E1',
  ink: '#1F1B1D',
  ink2: '#4A4448',
  ink3: '#7A7176',
  line: '#E9E4E6',
  bg: '#FAF8F7',
  bg2: '#F2EFEE',
  white: '#FFFFFF',
};

export const helpEase = 'cubic-bezier(.22,.61,.36,1)';

export const cardShadow = '0 1px 0 rgba(31,27,29,0.02), 0 10px 22px -16px rgba(31,27,29,0.16)';
export const cardShadowHover = '0 1px 0 rgba(31,27,29,0.02), 0 18px 28px -14px rgba(218,0,103,0.22)';
// Más marcada que cardShadow: en mobile los grupos de preguntas necesitan despegarse del fondo.
export const faqGroupShadow = '0 1px 0 rgba(31,27,29,0.02), 0 8px 18px -10px rgba(31,27,29,0.20)';
// Para cards blancas sobre fondo blanco ("Temas" en desktop): cardShadow se apoya
// en el contraste con #FAF8F7 y sobre #FFFFFF desaparece.
export const cardShadowOnWhite = '0 2px 4px rgba(31,27,29,0.04), 0 12px 32px -8px rgba(31,27,29,0.18)';
export const panelShadow = '0 1px 0 rgba(31,27,29,0.02), 0 16px 36px -22px rgba(31,27,29,0.18)';

export const HELP_MAX_WIDTH = 1180;

// El header es fixed: sin este margen el scroll a una categoría deja tapado el título del grupo.
export const HELP_SCROLL_MARGIN_TOP = '126px';

export const eyebrowSx = {
  display: 'block',
  fontWeight: 600,
  fontSize: 12,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: helpColors.pink,
};

export const sectionTitleSx = {
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: helpColors.ink,
};

export const answerTextSx = {
  fontSize: 14,
  lineHeight: 1.6,
  color: helpColors.ink2,
  textAlign: 'left',
  '& + &': { marginTop: '10px' },
};

export const answerLinkSx = {
  color: helpColors.pink,
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
};
